import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationBrand from '@segment/templates/NavigationBrand'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import ExploreTheProduct from './components/ExploreTheProduct'
import GettingStarted from './components/GettingStarted'

import ogImagePng from './assets/OgProductTour.jpg'

const ProductTour = () => (
  <AppearanceProvider appearance="twilioLight">
    <Layout
      pageTitle="Segment Product Tour | Twilio Segment"
      pageDescription="In this interactive product tour, you'll see how Segment collects, collects and standardizes data across your tech stack to enable all teams to use customer data to hit their goals."
      pageOG={ogImagePng}
    >
      <NavigationBrand />
      <Hero />
      <Main>
        <ExploreTheProduct />
        <GettingStarted />
      </Main>
    </Layout>
    <Footer />
  </AppearanceProvider>
)

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default ProductTour
